import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useState } from 'react';
import PrintButton from "./PrinterButton";

const API_URL = process.env.REACT_APP_API_URL

function Ticket({ ticket, onUpdate }) {
    const [status, setStatus] = useState(ticket.Estado); // Track ticket status locally

    const handleUpdateStatus = async () => {
        try {
            const url = `${API_URL}/free-ticket/${ticket.id}`
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Estado: 'Closed' }), 
            });

            if (response.ok) {
                const updatedTicket = await response.json();
                setStatus(updatedTicket.Estado); 
                onUpdate(ticket.id, updatedTicket); 
                toast.success("Marcado como cerrado"); 
            } else {
                toast.error("Fallo al cerrar ticket");
            }
        } catch (error) {
            console.error('Error updating ticket:', error);
            toast.error("Error actualizando el ticket");
        }
    };

    return (
        <div className="card p-3 mb-3 shadow-sm">
            <h4 className="card-title">{ticket.Placa}</h4>
            <p className="text-muted">Entrada: {new Date(ticket.TiempoEntrada).toLocaleString()}</p>
            <p>
                Salida: {ticket.TiempoSalida 
                    ? new Date(ticket.TiempoSalida).toLocaleString() 
                    : "No registrado"}
            </p>
            <p>
                Estado:{" "}
                <span className={`badge ${status === "Active" ? "bg-success" : "bg-danger"}`}>
                    {status}
                </span>
            </p>

            {status === "Active" && (
                <>
                <button 
                    className="btn btn-warning mb-2"
                    onClick={handleUpdateStatus}
                >
                    Mark as Closed
                </button>
                <PrintButton ticket={ticket}/>
                </>
                
            )}
            
        </div>
    );
}

export default Ticket;
